const OG_Base_URL =
  "https://wooting-web-files.ams3.cdn.digitaloceanspaces.com/public/wooting-hub";

function generateURLForImage(uri: string) {
  return `${OG_Base_URL}/${uri}`;
}

export const WootingCDN = {
  defaultProfile: generateURLForImage("default_profile.png"),
  login: {
    wootingTwoHe: generateURLForImage("wooting-two-he.png"),
    wristrest: generateURLForImage("wrist-rest.png"),
    lekkerEdition: generateURLForImage("wooting-two-lekker.png"),
  },
  knowledgeBase: generateURLForImage("knowledge_base.png"),
  warranty: generateURLForImage("warranty%20%281%29.png"),
  defaultImage: generateURLForImage("fallback_w.png"),
};
